import React, { useCallback } from 'react';
import { makeStyles } from '@mui/styles';
import {Accordion, AccordionDetails, AccordionSummary,
  Typography, Grid } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import { Title } from './Title';

const useStyles = makeStyles((theme) => ({
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
    marginLeft: 200,
    marginTop: 7
  },
  link: {
    position: 'absolute',
    right: '62px',
    top: '5px'
  },
  donationButton: {
    height: '25px',
    fontSize: '0.7rem'
  }
}));

export default function GridGroup({ title, itemAmount, children, onTitleClick, onChange, style, onNewDonationClick }) {
  const classes = useStyles();
  const handleOnTitleClick = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    if (typeof onTitleClick === 'function') {
      onTitleClick(title);
    }
  }, [onTitleClick]);

  return (
    <Accordion
      defaultExpanded
      elevation={2}
      {...{ TransitionProps, onChange }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls={`${title}-content"`}
        id={`${title}-header`}
      >
        <Grid
          container
          justifyContent="space-between"
        >
          <Grid item xs={5}>
            <Title onClick={handleOnTitleClick}>{title}</Title>
          </Grid>
          <Grid item>
            <Typography>{itemAmount}</Typography>
          </Grid>
        </Grid>
      </AccordionSummary>
      <AccordionDetails {...{ style }}>
        {children}
      </AccordionDetails>
    </Accordion>    
  );
}

const TransitionProps = {
  timeout: 0,
};